<div
    *ngIf="form?.get('newCustomer')"
    [formGroup]="newCustomer">
    <div class="row">
        <div class="col-6">
            <label class="padded-top-gray-label">Customer First Name* :</label>
            <input
                type="text"
                class="normal-text-input"
                placeholder="Enter first name"
                formControlName="firstname"
                [ngClass]="{
                    'normal-text-input--invalid':
                        newCustomer.get('firstname')?.invalid &&
                        (newCustomer.get('firstname')?.dirty || newCustomer.get('firstname')?.touched)
                }" />
        </div>

        <div class="col-6">
            <label class="padded-top-gray-label">Customer Second Name* :</label>
            <input
                type="text"
                class="normal-text-input"
                placeholder="Enter second name"
                formControlName="surname"
                [ngClass]="{
                    'normal-text-input--invalid':
                        form.get('surname')?.invalid && (form.get('surname')?.dirty || form.get('surname')?.touched)
                }" />
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <label class="padded-top-gray-label">Customer Phone Number* :</label>
            <div class="phone-input-holder">
                <ys-phone-input formControlName="phone"></ys-phone-input>
            </div>
        </div>
        <div class="col-6">
            <label class="padded-top-gray-label">Customer Email* :</label>
            <input
                type="text"
                class="normal-text-input"
                placeholder="Enter email"
                formControlName="email"
                [ngClass]="{
                    'normal-text-input--invalid':
                        form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)
                }" />
        </div>
    </div>
</div>
